import React from 'react';
import OutsideChatPromptChooser from './OutsideChatPromptChooser';
import { PROMPT_SIGNATURE_SOFT_REJECT } from '../../utils/writerCopy';
import './PromptSignatureSoftNotice.css';

/**
 * Post-upload soft redirect (#1245, #1266). The file stays in the pool.
 * The writer copies Prompt A or Prompt B. Default is B.
 */
export default function PromptSignatureSoftNotice({ legacy = false, legacyCopy = '' }) {
  return (
    <div className="prompt-stamp-notice" role="status">
      <p>{legacy && legacyCopy ? legacyCopy : PROMPT_SIGNATURE_SOFT_REJECT}</p>
      <OutsideChatPromptChooser />
    </div>
  );
}
